import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const badge = css`
  block-size: ${spacing(4)};
`

export const badgeSize = {
  s: css`
    inline-size: ${spacing(10)};
  `,
  m: css`
    inline-size: ${spacing(15)};
  `,
  l: css`
    inline-size: ${spacing(22)};
  `,
}
